import {
  Add,
  Button,
  FormCard,
  FormItem,
  Input,
  TextArea,
  Trash,
  theme
} from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { Form as AntdForm } from 'antd'
import { Text } from '@lmc/ui-kit/src/general'
import { DeleteButtonText } from 'screens/Residents/screens/ResidentProfileScreen/styledComponents'

export const ScenariosFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <AntdForm.List name="scenarios">
      {(fields, { add, remove }) => (
        <FormCard
          title={t(supConstants.CONTINGENCY_PLANS)}
          rightChildren={
            <Button
              type="button"
              variant="text"
              icon={<Add />}
              onClick={() => add()}
            >
              {t(supConstants.ADD_SCENARIO)}
            </Button>
          }
        >
          {fields.map((field, i) => (
            <FormCard
              level={2}
              key={field.name}
              title={`${t(supConstants.SCENARIO)} ${i + 1}`}
              rightChildren={
                <Button
                  type="button"
                  variant="text"
                  icon={<Trash color={theme.color.neutral.color4} />}
                  onClick={() => remove(field.name)}
                >
                  <DeleteButtonText>
                    {t(supConstants.DELETE_SCENARIO)}
                  </DeleteButtonText>
                </Button>
              }
            >
              <FormItem
                label={<Text>{t(supConstants.TRIGGER_FACTOR)}</Text>}
                name={[field.name, 'triggerFactor']}
                key={['scenarios', field.key, 'trigger-factor'].join('-')}
                rules={[
                  {
                    required: true,
                    message: `${t(supConstants.PLEASE_ENTER)} ${t(
                      supConstants.TRIGGER_FACTOR
                    )}`
                  }
                ]}
              >
                <Input maxLength={50} />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.WHAT_SHOULD_HAPPEN)} </Text>}
                name={[field.name, 'actionPlan']}
                key={['scenarios', field.key, 'actionPlan'].join('-')}
              >
                <TextArea
                  autoSize={{
                    minRows: 3
                  }}
                />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.WHO_SHOULD_BE_CONTACTED)}</Text>}
                name={[field.name, 'contactPerson']}
                key={['scenarios', field.key, 'contactPerson'].join('-')}
              >
                <Input maxLength={50} />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.ROLE)}</Text>}
                name={[field.name, 'role']}
                key={['scenarios', field.key, 'role'].join('-')}
              >
                <Input maxLength={100} />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.ANTICIPATORY_MEDS)}</Text>}
                name={[field.name, 'anticipatoryEquipment']}
                key={['scenarios', field.key, 'anticipatoryEquipment'].join(
                  '-'
                )}
              >
                <Input maxLength={100} />
              </FormItem>
            </FormCard>
          ))}
        </FormCard>
      )}
    </AntdForm.List>
  )
}
